import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const MainLayoutContainer = styled(Box)`
  display: flex;
  justify-content: center;
  background: ${theme.colors.pageBackground};
  padding: 0;
`

export const MainLayoutWrapper = styled(Box)<{ isSettingsPage: string }>`
  ${({ isSettingsPage }) =>
    isSettingsPage === 'true' &&
    `
      overflow-y: hidden;
  `};
`
